<template>
  <div>
    <div class="spnod-modal__mask" v-if="mutableShow">
      <div class="spnod-modal__wrapper">
        <div class="spnod-modal__container">

          <div class="spnod-modal__header">
            <div class="spnod-modal__close" v-if="hasClose !== 'false'" v-on:click.stop.prevent="close">
              x
            </div>
            <slot name="header"></slot>
          </div>
          <div class="spnod-modal__body">
            <long-form-h-t-m-l :modalBody="modalBody"></long-form-h-t-m-l>
          </div>
          <div class="spnod-modal__footer">
            <form :id="formName" :ref="formName" autocomplete="off">
              <form-generator
                :schema="schema"
                v-model="model"
                @checkValues="checkValidity('signUpForm', $event)">
              </form-generator>
              <slot name="action">
                <button type="button" class="spnod-form__button spnod-button--primary" v-on:click.stop.prevent="close" v-if="hasCloseBtn">Close</button>
              </slot>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="spnod-form__fieldset spnod-form__fieldset--no-background" v-if="hasInput === 'true'">
      <label class="spnod-checkbox__label" v-on:click.stop.prevent="mutableShow = true">
        <input type="checkbox" class="spnod-checkbox" :checked="isChecked">
        <span class="spnod-radio--styled flaticon--center">
          <span class="spnod-radio--checked fi2 flaticon2-checked-1 flaticon--white"></span>
        </span>
        <span class="spnod-radio__label spnod-radio__label--small">Accept Terms and Conditions</span>
      </label>
    </div>
  </div>
</template>

<script>
import LongFormHTML from '../LongFormHTML/LongFormHTML'
import { mapGetters } from 'vuex'

export default {
  name: 'CheckboxModal',
  data () {
    return {
      isChecked: false,
      mutableShow: this.show || false
    }
  },
  computed: {
    ...mapGetters([
      'getFormData'
    ])
  },
  props: [
    'dataType',
    'formName',
    'hasClose',
    'hasCloseBtn',
    'hasInput',
    'model',
    'schema',
    'show',
    'modalBody'
  ],
  mounted () {
    this.checkValidity()
  },
  methods: {
    close () {
      this.mutableShow = false
      this.$emit('checkValues')
      this.$emit('closeModal')
    },
    action () {
      this[this.myOptions.action]()
    },
    checkValidity () {
      let i = 0
      let isChecked = true
      if (this.schema) {
        let schemaLength = this.schema.length
        for (i = 0; i < schemaLength; i++) {
          if (this.getFormData.hasOwnProperty(this.schema[i].name) === false || (this.getFormData[this.schema[i].name] !== true && this.getFormData[this.schema[i].name] instanceof Date !== true)) {
            isChecked = false
            break
          }
        }
        this.isChecked = isChecked
        this.$emit('checkValues')
      }
    }
  },
  components: { FormGenerator: () => import('../../components/FormGenerator/FormGenerator'), LongFormHTML },
  watch: {
    modalBody: function (newVal, oldVal) {
      this.$store.commit('LONGFORMHTML', this.modalBody)
    },
    show: function (newVal, oldVal) {
      this.mutableShow = newVal
    },
    getFormData: function (newVal, oldVal) {
      setTimeout(() => this.checkValidity(), 200)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/CheckboxModal/CheckboxModal.vue?602603fa